{
  "pages": {
    "sheetsTitle": "Phiếu KPI",
    "addSheetTitle": "Tạo phiếu KPI",
    "addCycleTitle": "Tạo kỳ KPI",
    "editCycleTitle": "Sửa kỳ KPI",
    "sheetDetailsTitle": "Chi tiết phiếu KPI",
    "sheetName": "Phiếu KPI {{staffName}} {{period}}",
    "cycleDetailsTitle": "Chi tiết kỳ KPI",
    "metricsTitle": "Danh mục chỉ tiêu KPI",
    "myKpiTitle": "KPI của tôi",
    "hubTitle": "KPI",
    "permissionDenied": "Bạn không có quyền xem KPI.",
    "createPermissionDenied": "Bạn không có quyền tạo phiếu KPI.",
    "createCyclePermissionDenied": "Bạn không có quyền tạo kỳ KPI.",
    "metricsPermissionDenied": "Bạn không có quyền xem danh mục chỉ tiêu.",
    "tabs": {
      "cycles": "Kỳ KPI",
      "sheets": "Phiếu KPI",
      "metrics": "Danh mục chỉ tiêu",
      "templates": "Mẫu phiếu",
      "mine": "KPI của tôi"
    },
    "tabsAria": "Phần KPI"
  },
  "status": {
    "draft": "Nháp",
    "locked": "Đã khóa",
    "active": "Đang áp dụng",
    "closed": "Đã chốt"
  },
  "fields": {
    "name": "Tên phiếu",
    "cycleName": "Tên kỳ",
    "period": "Kỳ (tháng)",
    "status": "Trạng thái",
    "clinic": "Chi nhánh",
    "clinicOptional": "Chi nhánh (tuỳ chọn)",
    "metrics": "Chỉ tiêu",
    "staff": "Nhân viên",
    "staffCode": "Mã NV",
    "department": "Bộ phận",
    "designation": "Chức danh",
    "target": "Chỉ tiêu",
    "actual": "Thực tế",
    "percent": "Hoàn thành",
    "payoutAmount": "Thưởng KPI",
    "payoutRate": "Đơn giá chốt",
    "payoutTotal": "Tổng thưởng KPI",
    "template": "Mẫu phiếu",
    "sheetScore": "Mức hoàn thành",
    "staffScore": "Mức hoàn thành",
    "source": "Nguồn",
    "unit": "Đơn vị",
    "weight": "Trọng số",
    "metricName": "Tên chỉ tiêu",
    "kind": "Loại",
    "departmentApplies": "Áp dụng cho",
    "departmentAll": "Tất cả phòng ban",
    "departmentPlaceholder": "Chọn phòng ban…",
    "autoCode": "Mã đo tự động",
    "catalogService": "Dịch vụ catalog",
    "catalogStep": "Bước {{order}}",
    "journalItem": "Mục nhật ký điều trị",
    "journalWorkRole": "Vai đếm",
    "createdAt": "Ngày tạo",
    "updatedAt": "Cập nhật lần cuối",
    "createdBy": "Người tạo",
    "updatedBy": "Người chỉnh sửa",
    "lockedAt": "Ngày khóa",
    "lockedBy": "Người khóa",
    "closedAt": "Ngày chốt",
    "closedBy": "Người chốt"
  },
  "source": {
    "auto": "Tự động",
    "manual": "Tự nhập"
  },
  "unit": {
    "count": "Số lượng",
    "money": "Tiền",
    "days": "Ngày"
  },
  "kind": {
    "system": "Hệ thống",
    "custom": "Tuỳ chỉnh"
  },
  "journalWorkRoles": {
    "work": "Bác sĩ hoặc phụ tá",
    "performed": "Bác sĩ thực hiện",
    "supported": "Phụ tá",
    "inner": "Phụ tá vòng trong",
    "outer": "Phụ tá vòng ngoài"
  },
  "table": {
    "name": "Tên",
    "period": "Kỳ",
    "status": "Trạng thái",
    "score": "Mức hoàn thành",
    "staffCount": "NV",
    "sheetCount": "Số phiếu",
    "metricCount": "Số chỉ tiêu",
    "actions": "Thao tác"
  },
  "actions": {
    "addSheet": "Tạo phiếu",
    "addCycle": "Tạo kỳ",
    "editCycle": "Sửa kỳ",
    "generate": "Tạo phiếu",
    "generating": "Đang tạo phiếu...",
    "cloneCycle": "Nhân bản kỳ",
    "lock": "Khóa kỳ",
    "locking": "Đang khóa...",
    "unlock": "Mở khóa kỳ",
    "unlocking": "Đang mở khóa...",
    "backToCycle": "Về kỳ KPI",
    "cycleActions": "Thao tác kỳ KPI",
    "addMetric": "Thêm chỉ tiêu",
    "recalculate": "Tính lại",
    "recalculating": "Đang tính lại...",
    "close": "Chốt kỳ",
    "closing": "Đang chốt kỳ...",
    "changeStatus": "Đổi trạng thái kỳ KPI",
    "reopen": "Mở lại",
    "reopening": "Đang mở lại...",
    "activate": "Áp dụng",
    "saveDraft": "Lưu nháp",
    "deactivateMetric": "Ngừng dùng",
    "activateMetric": "Kích hoạt lại",
    "editMetric": "Sửa chỉ tiêu",
    "viewMetric": "Xem chi tiết",
    "history": "Lịch sử",
    "viewMetrics": "Danh mục chỉ tiêu",
    "myKpi": "KPI của tôi"
  },
  "empty": {
    "sheets": "Chưa có phiếu KPI. Mở một kỳ rồi tạo phiếu từ mẫu.",
    "sheetSearch": "Không tìm thấy phiếu KPI phù hợp.",
    "cycles": "Chưa có kỳ KPI.",
    "cycleSearch": "Không tìm thấy kỳ KPI phù hợp.",
    "cycleSheets": "Kỳ chưa có phiếu — generate từ mẫu để thêm nhân viên.",
    "assignments": "Chưa có dòng chỉ tiêu.",
    "myKpi": "Bạn chưa được giao KPI trong kỳ này.",
    "metrics": "Chưa có chỉ tiêu."
  },
  "listFilters": {
    "trigger": "Bộ lọc",
    "title": "Bộ lọc",
    "apply": "Áp dụng",
    "clearAll": "Xóa lọc",
    "selectPeriod": "Chọn kỳ",
    "selectStatus": "Chọn trạng thái",
    "selectCycle": "Chọn kỳ KPI",
    "cycleAll": "Tất cả kỳ KPI",
    "selectStaff": "Chọn nhân viên",
    "staffAll": "Tất cả nhân viên"
  },
  "sheets": {
    "searchPlaceholder": "Tìm theo tên nhân viên, tên phiếu hoặc tên kỳ…",
    "filters": {
      "statusAll": "Tất cả trạng thái"
    }
  },
  "cycles": {
    "searchPlaceholder": "Tìm theo tên kỳ…",
    "filters": {
      "periodAll": "Tất cả",
      "selectStatus": "Chọn trạng thái",
      "statusAll": "Tất cả trạng thái"
    }
  },
  "metrics": {
    "searchPlaceholder": "Tìm theo tên chỉ tiêu…",
    "emptySearch": "Không tìm thấy chỉ tiêu phù hợp.",
    "ariaActions": "Thao tác chỉ tiêu",
    "noActions": "Không có thao tác",
    "editTitle": "Sửa chỉ tiêu",
    "detailTitle": "Chi tiết chỉ tiêu",
    "noMetricSelected": "Chưa chọn chỉ tiêu.",
    "notAvailable": "—",
    "auditSection": "Thông tin hệ thống",
    "autoHint": "Thực tế được hệ thống đo tự động từ dữ liệu phòng khám khi tính lại / chốt phiếu.",
    "catalogHint": "Số lần phụ tá việc này trong kỳ — khớp ô Bảng việc tab Theo phụ tá.",
    "journalHint": "Mục không kíp 2 vòng: một chỉ tiêu, đếm bác sĩ hoặc phụ tá. Mục bật kíp 2 vòng: bác sĩ / vòng trong / vòng ngoài.",
    "catalogNameLocked": "Tên lấy từ danh mục dịch vụ.",
    "journalNameLocked": "Tên lấy từ mục nhật ký. Kíp 2 vòng thêm hậu tố bác sĩ / vòng.",
    "journalDepartmentLocked": "Mục thường: Phụ tá và Bác sĩ điều trị. Kíp 2 vòng: bác sĩ một chỉ tiêu, vòng trong/ngoài cho Phụ tá.",
    "manualHint": "Thực tế do người dùng nhập trên phiếu KPI.",
    "tabInfo": "Thông tin",
    "activityEmpty": "Chưa có hoạt động cho chỉ tiêu này.",
    "filters": {
      "trigger": "Bộ lọc",
      "title": "Bộ lọc",
      "apply": "Áp dụng",
      "clearAll": "Xóa lọc",
      "kindAll": "Tất cả loại",
      "sourceAll": "Tất cả nguồn",
      "unitAll": "Tất cả đơn vị",
      "statusAll": "Tất cả trạng thái",
      "selectKind": "Chọn loại",
      "selectSource": "Chọn nguồn",
      "selectUnit": "Chọn đơn vị",
      "selectStatus": "Chọn trạng thái"
    }
  },
  "validation": {
    "nameRequired": "Nhập tên phiếu.",
    "cycleNameRequired": "Nhập tên kỳ.",
    "cycleNamePlaceholder": "Nhập tên kỳ",
    "periodRequired": "Chọn kỳ.",
    "clinicRequired": "Chọn chi nhánh.",
    "selectClinic": "Chọn chi nhánh",
    "metricsRequired": "Chọn ít nhất một chỉ tiêu.",
    "staffRequired": "Chọn ít nhất một nhân viên.",
    "selectStaff": "Chọn nhân viên",
    "templateRequired": "Chọn mẫu phiếu.",
    "selectTemplate": "Chọn mẫu phiếu",
    "metricNameRequired": "Nhập tên chỉ tiêu.",
    "metricNamePlaceholder": "Nhập tên chỉ tiêu",
    "weightPlaceholder": "Ví dụ: 1",
    "weightInvalid": "Nhập trọng số lớn hơn hoặc bằng 0.",
    "itemMetricRequired": "Chọn chỉ tiêu.",
    "defaultTargetPlaceholder": "Ví dụ: 0",
    "defaultTargetInvalid": "Nhập target lớn hơn hoặc bằng 0."
  },
  "toasts": {
    "createSuccess": "Đã tạo phiếu KPI.",
    "cycleCreateSuccess": "Đã tạo kỳ KPI.",
    "cycleUpdateSuccess": "Đã cập nhật kỳ KPI.",
    "generateSuccess": "Đã tạo phiếu từ mẫu.",
    "cloneCycleSuccess": "Đã nhân bản kỳ KPI.",
    "lockSuccess": "Đã khóa kỳ KPI.",
    "unlockSuccess": "Đã mở khóa kỳ KPI.",
    "updateSuccess": "Đã cập nhật phiếu KPI.",
    "recalcSuccess": "Đã tính lại KPI.",
    "closeSuccess": "Đã chốt kỳ KPI.",
    "reopenSuccess": "Đã mở lại kỳ KPI.",
    "metricCreateSuccess": "Đã thêm chỉ tiêu.",
    "metricUpdateSuccess": "Đã cập nhật chỉ tiêu.",
    "metricDeactivateSuccess": "Đã ngừng dùng chỉ tiêu.",
    "metricActivateSuccess": "Đã kích hoạt lại chỉ tiêu.",
    "actualUpdateSuccess": "Đã cập nhật thực tế.",
    "targetUpdateSuccess": "Đã cập nhật chỉ tiêu.",
    "saveFailed": "Không lưu được. Thử lại."
  },
  "hints": {
    "systemMetrics": "Chỉ tiêu hệ thống được đo tự động từ dữ liệu phòng khám.",
    "manualActual": "Chỉ tiêu tự nhập — click số Thực tế để sửa (khi kỳ nháp hoặc đã khóa).",
    "manualTarget": "Click số Chỉ tiêu để sửa target (chỉ khi kỳ còn nháp).",
    "closedFrozen": "Kỳ đã chốt. Không thể chỉnh sửa target và thực tế. Thưởng KPI đã khoá.",
    "cycleEditLockedFields": "Tháng và chi nhánh không thể chỉnh sửa sau khi tạo.",
    "payoutOnClose": "Thưởng KPI = áp dụng chính sách thưởng (đối tượng + hiệu lực + công thức) khi chốt kỳ."
  },
  "confirms": {
    "closeTitle": "Chốt kỳ KPI?",
    "closeMessage": "Kỳ sẽ tính lại lần cuối và khóa thưởng KPI. Không sửa thực tế sau khi chốt.",
    "reopenTitle": "Mở lại kỳ KPI?",
    "reopenMessage": "Thưởng đã chốt sẽ bị xóa. Kỳ trở về Đã khóa."
  },
  "bonus": {
    "title": "Chính sách thưởng KPI",
    "hint": "Mỗi chính sách gắn đối tượng + hiệu lực; bên trong là quy tắc công thức theo chỉ tiêu. Áp khi chốt phiếu.",
    "createTitle": "Tạo chính sách thưởng",
    "editTitle": "Sửa chính sách thưởng",
    "detailTitle": "Chi tiết chính sách thưởng",
    "noPolicySelected": "Chưa chọn chính sách.",
    "notAvailable": "—",
    "tabInfo": "Thông tin",
    "rulesSection": "Quy tắc công thức",
    "auditSection": "Thông tin hệ thống",
    "activityEmpty": "Chưa có hoạt động cho chính sách này.",
    "dialogSteps": {
      "policy": "Chính sách",
      "rules": "Quy tắc",
      "policyDesc": "Tên, phạm vi, đối tượng và hiệu lực",
      "rulesDesc": "Công thức thưởng theo chỉ tiêu",
      "aria": "Các bước chính sách thưởng",
      "next": "Tiếp theo",
      "back": "Quay lại"
    },
    "priorityShow": "Xem thứ tự ưu tiên",
    "priorityHide": "Ẩn thứ tự ưu tiên",
    "priorityDetail": "Khi chốt: cá nhân → bộ phận → mọi người. Cùng cấp thì chi nhánh ghi đè tổ chức.",
    "scopeOrg": "Tổ chức",
    "scopeClinic": "Chi nhánh",
    "scopeLabel": "Phạm vi",
    "filterAll": "Tất cả",
    "filters": {
      "trigger": "Bộ lọc",
      "title": "Bộ lọc",
      "apply": "Áp dụng",
      "clearAll": "Xóa lọc",
      "searchPlaceholder": "Tìm theo tên chính sách…",
      "statusAll": "Tất cả trạng thái",
      "audienceAll": "Tất cả đối tượng",
      "selectScope": "Chọn phạm vi",
      "selectClinic": "Chọn chi nhánh",
      "selectStatus": "Chọn trạng thái",
      "selectAudience": "Chọn đối tượng",
      "clinicAll": "Tất cả chi nhánh",
      "emptySearch": "Không tìm thấy chính sách phù hợp."
    },
    "ariaActions": "Thao tác chính sách thưởng",
    "noActions": "Không có thao tác",
    "clinicModeLabel": "Cách áp dụng chi nhánh",
    "clinicInherit": "Theo tổ chức",
    "clinicOverride": "Ghi đè riêng",
    "clinicInheritHint": "Chi nhánh đang dùng chính sách tổ chức. Chọn Ghi đè để cấu hình riêng.",
    "emptyTitle": "Chưa có chính sách thưởng",
    "emptyRules": "Thêm quy tắc công thức để gắn thưởng theo chỉ tiêu.",
    "noMetrics": "Chưa có chỉ tiêu đang dùng. Tạo chỉ tiêu trước khi thêm quy tắc.",
    "rulesCount": "{{count}} quy tắc",
    "fields": {
      "name": "Tên chính sách",
      "namePlaceholder": "Nhập tên chính sách",
      "scope": "Phạm vi áp dụng",
      "metric": "Chỉ tiêu",
      "mode": "Cách tính",
      "audience": "Đối tượng áp dụng",
      "audiencePlaceholder": "Chọn đối tượng",
      "department": "Bộ phận",
      "departmentPlaceholder": "Chọn bộ phận",
      "departmentHint": "Vui lòng chọn bộ phận áp dụng",
      "staff": "Nhân viên",
      "status": "Trạng thái",
      "effectiveFrom": "Hiệu lực từ",
      "effectiveTo": "Hiệu lực đến",
      "effectiveToHint": "Để trống = không giới hạn",
      "openEnded": "Không hạn",
      "unitAmount": "Đơn giá / đơn vị (VND)",
      "unitAmountPlaceholder": "Nhập đơn giá",
      "minPercent": "Mốc % tối thiểu",
      "minActual": "Mốc số tối thiểu",
      "amount": "Số tiền",
      "amountPlaceholder": "Nhập số tiền",
      "rules": "Số quy tắc"
    },
    "statuses": {
      "active": "Đang áp dụng",
      "inactive": "Ngừng dùng"
    },
    "summary": {
      "unit": "đv",
      "bands": "{{count}} mốc %",
      "tiers": "{{count}} bậc"
    },
    "audiences": {
      "all": "Mọi người",
      "department": "Theo bộ phận",
      "staff": "Theo cá nhân"
    },
    "picker": {
      "selectAll": "Chọn tất cả",
      "unselectAll": "Bỏ chọn tất cả",
      "bulkAction": "Chọn",
      "selectedCount": "Đã chọn {{count}}",
      "search": "Tìm…",
      "allDepartments": "Tất cả bộ phận",
      "filterByDepartmentHint": "Bấm tên bộ phận để lọc",
      "columnName": "Tên",
      "columnStaffName": "Họ và tên",
      "columnDepartment": "Bộ phận",
      "columnDesignation": "Chức danh",
      "empty": "Không có mục nào",
      "emptyDepartments": "Chưa có bộ phận",
      "emptyStaff": "Chưa có nhân viên"
    },
    "audienceSummary": {
      "department": "Theo bộ phận: {{names}}",
      "staff": "Theo cá nhân: {{names}}",
      "more": "+{{count}}"
    },
    "modes": {
      "perUnit": "Theo số làm được",
      "percentBands": "Theo % hoàn thành",
      "quantityTiers": "Theo bậc số lượng"
    },
    "actions": {
      "addPolicy": "Thêm chính sách",
      "addRule": "Thêm quy tắc",
      "removeRule": "Xóa quy tắc",
      "addBand": "Thêm mốc %",
      "addTier": "Thêm bậc",
      "removeBand": "Xóa",
      "save": "Lưu chính sách",
      "view": "Xem chi tiết",
      "edit": "Sửa",
      "deactivate": "Ngừng dùng",
      "goTemplates": "Gắn thưởng trong Mẫu phiếu"
    },
    "toasts": {
      "saveSuccess": "Đã lưu chính sách thưởng KPI.",
      "deactivateSuccess": "Đã ngừng dùng chính sách thưởng."
    },
    "validation": {
      "nameRequired": "Nhập tên chính sách.",
      "audienceRequired": "Chọn đối tượng áp dụng.",
      "departmentRequired": "Chọn ít nhất một bộ phận.",
      "effectiveFromRequired": "Chọn ngày bắt đầu hiệu lực.",
      "rulesRequiredWhenActive": "Chính sách đang áp dụng cần ít nhất một quy tắc công thức."
    }
  },
  "templates": {
    "hint": "Khai báo ai được áp dụng, từ ngày nào, chỉ tiêu nào và cách tính tiền. Sinh phiếu từ mẫu; đổi mẫu sau không đổi phiếu đã tạo.",
    "createTitle": "Tạo mẫu KPI",
    "editTitle": "Sửa mẫu KPI",
    "dialogSteps": {
      "info": "Thông tin chung",
      "items": "Chỉ tiêu và cách tính tiền",
      "aria": "Các bước mẫu KPI",
      "next": "Tiếp theo",
      "back": "Quay lại"
    },
    "empty": "Chưa có mẫu KPI.",
    "emptySearch": "Không tìm thấy mẫu phù hợp.",
    "searchPlaceholder": "Tìm theo tên mẫu, mô tả, bộ phận…",
    "filters": {
      "trigger": "Bộ lọc",
      "title": "Bộ lọc",
      "apply": "Áp dụng",
      "clearAll": "Xóa lọc",
      "selectStatus": "Chọn trạng thái",
      "statusAll": "Tất cả trạng thái"
    },
    "ariaActions": "Thao tác mẫu phiếu",
    "fields": {
      "name": "Tên mẫu",
      "namePlaceholder": "Nhập tên mẫu phiếu",
      "description": "Mô tả",
      "descriptionPlaceholder": "Nhập mô tả",
      "department": "Áp dụng cho",
      "departmentPlaceholder": "Chọn bộ phận",
      "departmentNone": "Chọn bộ phận",
      "staffApply": "Nhân viên áp dụng",
      "staffPlaceholder": "Chọn nhân viên",
      "metricPlaceholder": "Chọn chỉ tiêu",
      "status": "Trạng thái",
      "items": "Chỉ tiêu và cách tính tiền",
      "itemCount": "Số chỉ tiêu",
      "defaultTarget": "Target",
      "payout": "Tiền thưởng",
      "targetUnused": "—",
      "effectiveFrom": "Từ ngày",
      "effectiveTo": "Đến ngày",
      "effectiveToHint": "Để trống nếu không hạn.",
      "openEnded": "Không hạn"
    },
    "staffTable": {
      "search": "Tìm nhân viên…",
      "allDepartments": "Tất cả bộ phận",
      "selectAll": "Chọn tất cả nhân viên đang lọc",
      "selectedCount": "Đã chọn {{count}}/{{total}}",
      "empty": "Chưa có nhân viên.",
      "noMatch": "Không có nhân viên khớp bộ lọc."
    },
    "emptyItems": "Chưa có chỉ tiêu. Bấm Thêm chỉ tiêu để bắt đầu.",
    "validation": {
      "nameRequired": "Nhập tên mẫu.",
      "effectiveFromRequired": "Chọn ngày bắt đầu.",
      "audienceRequired": "Chọn đối tượng áp dụng.",
      "departmentRequired": "Chọn bộ phận.",
      "staffRequired": "Chọn ít nhất một nhân viên."
    },
    "actions": {
      "add": "Thêm mẫu",
      "addItem": "Thêm chỉ tiêu",
      "clone": "Nhân bản",
      "deactivate": "Ngừng dùng",
      "apply": "Dùng mẫu",
      "clonePeriod": "Tạo kỳ mới"
    },
    "toasts": {
      "saveSuccess": "Đã lưu mẫu KPI.",
      "cloneSuccess": "Đã nhân bản mẫu KPI.",
      "deactivateSuccess": "Đã ngừng dùng mẫu KPI.",
      "clonePeriodSuccess": "Đã tạo phiếu kỳ mới."
    }
  },
  "history": {
    "metricTitle": "Lịch sử chỉ tiêu",
    "metricEmpty": "Chưa có lịch sử thay đổi cho chỉ tiêu này.",
    "templateTitle": "Lịch sử mẫu phiếu",
    "templateEmpty": "Chưa có lịch sử thay đổi cho mẫu này.",
    "bonusTitle": "Lịch sử chính sách thưởng",
    "bonusEmpty": "Chưa có lịch sử thay đổi cho chính sách này.",
    "sheetTitle": "Lịch sử phiếu KPI",
    "sheetEmpty": "Chưa có lịch sử thay đổi cho phiếu này.",
    "cycleTitle": "Lịch sử kỳ KPI",
    "cycleEmpty": "Chưa có lịch sử thay đổi cho kỳ này."
  },
  "autoCodes": {
    "appointments_completed": "Lịch hẹn hoàn thành",
    "revenue_collected": "Doanh thu thu được",
    "treatments_completed": "Kế hoạch điều trị hoàn thành",
    "leads_won": "Lead thắng",
    "tasks_done": "Công việc hoàn thành",
    "lab_orders_completed": "Đơn lab hoàn thành",
    "prescriptions_written": "Đơn thuốc đã kê",
    "attendance_days": "Ngày công đủ",
    "work_performed": "Việc",
    "work_supported": "Việc hỗ trợ",
    "work_supported_inner": "Việc vòng trong",
    "work_supported_outer": "Việc vòng ngoài",
    "assistant_inner_sessions": "Ca phụ tá vòng trong",
    "assistant_outer_sessions": "Ca phụ tá vòng ngoài",
    "assistant_inner_procedures": "Việc điều trị phụ tá vòng trong",
    "assistant_outer_procedures": "Việc điều trị phụ tá vòng ngoài"
  }
}
